import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseService } from "./base.service";
import { Http } from '@angular/http';
import * as Enum from '../utils/enums';
import { Observable } from "rxjs";
import { RequestBuilder } from '../classes/request-builder';
import { TreeNode } from 'primeng/api';

@Injectable()
export class WbsService extends BaseService {

    /**
     * Costruttore
     * @param http Servizio di richieste HTTP 
     */
    constructor(http: Http, private HttpClient: HttpClient) {
        super(http)
    }

    /**
     * EXAMPLE WBS (MOKE)
     * REMOVE
     */
    getWbsmoke() {
        return this.HttpClient.get<any>('assets/listWbs.json')
            .toPromise()
            .then(res => <TreeNode[]>res.data);
    }

    /**
     * Get Filiera data
     * @param reqBuilder
     */
    getWbsData(reqBuilder?: RequestBuilder): Observable<any> {
        let payload
        if (reqBuilder) {
          payload = reqBuilder
        }
        return this.doPost('filiera/fetch', payload, Enum.CONTENT_TYPE_ENUM.APPLICATION_JSON)
      }
}